import Accordion from "accordion-js";
import "accordion-js/dist/accordion.min.css";

let firstAccordion = document.querySelector(".ac");
if (firstAccordion) {
  let firstImgSrc = firstAccordion.getAttribute("data-img");
  updateAccordionImage(firstImgSrc);

  // Inicjalizacja akordeonu z zdarzeniem onOpen
  new Accordion(".accordion", {
    onOpen: function (currentElement) {
      let imgSrc = currentElement.getAttribute("data-img");
      updateAccordionImage(imgSrc);
    },
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Wstaw pierwszy obrazek po wczytaniu strony
});

function updateAccordionImage(src) {
  let accordionImgDiv = document.querySelector(".accordion__img");
  let imgElement = accordionImgDiv.querySelector("img");

  if (!imgElement) {
    imgElement = document.createElement("img");
    imgElement.alt = "Obraz akordeonu";
    accordionImgDiv.appendChild(imgElement);
  }

  imgElement.classList.remove("is-visible");

  // Po krótkiej zwłoce zmieniamy źródło obrazka i dodajemy klasę do efektu przenikania
  setTimeout(function () {
    imgElement.src = src;
    imgElement.classList.add("is-visible");
  }, 50);
}
